import { Box, Heading, Spinner, Table, Text, TableContainer, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../auth/AuthProvider';
import RegistrationStateBadge from '../../parts/RegistrationStateBadge';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { Link, Route, Routes } from 'react-router-dom';
import CensusRender from './CensusRender';
import {useApiProvider} from '../../../api/ApiProvider';
import { InstructorText, RegistrationStateText, RequestTypeText } from '../../../model/census';
import LoadingWidget from "../../parts/LoadingWidget";
import ErrorMessage from '../../parts/ErrorMessage';
import { CensusForLeaderDTO } from '../../../model/censusForLeaderDTO';
import RequestStateBadge from '../../parts/RequestStateBadge';

function CensusesMenu(censuses : CensusForLeaderDTO[], isFetched : boolean, errorText : string) {

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100%"
            width="100vw"
            mt="100px"
        >   
            {errorText!="" ? (
                          <ErrorMessage text={errorText} />
            ) : (
                isFetched ? (
                    <>
                        {censuses.length ? (
                        <Box
                            minWidth="55%"
                        >
                            <TableContainer p="34">
                            <Heading p="5" as="h3" size="md" textAlign="start">Złożone wnioski</Heading>
                            <Table size='md'>
                                <Thead>
                                <Tr>
                                    <Th>#</Th>
                                    <Th>Imię i nazwisko</Th>
                                    <Th>Stopień</Th>
                                    <Th>Jednostka</Th>
                                    <Th>Złożony wniosek</Th>
                                    <Th>Status</Th>
                                    <Th></Th>
                                </Tr>
                                </Thead>
                                <Tbody>
                                {censuses.map((census, index) => (
                                <Tr key={index}>
                                    <Td>{index+1}</Td>
                                    <Td fontSize="sm" fontStyle="italic">{census.Name} {census.Surname}</Td>
                                    <Td fontSize="sm">{InstructorText[census.InstructorRank]}</Td>
                                    <Td fontSize="sm">{census.UnitName}</Td>
                                    <Td align='right'><RequestStateBadge requestState={RequestTypeText[census.Request!]} /></Td>
                                    <Td align='right'><RegistrationStateBadge registrationState={RegistrationStateText[census.RegistrationState]} /></Td>
                                    <Td><Link to={`./${census.CensusId}`}> Przejdź do wniosku <ChevronRightIcon/></Link></Td>
                                </Tr>
                                ))}
                                </Tbody>
                            </Table>
                            </TableContainer>
                        </Box>
                        ) :
                        <Heading p="5" as="h3" size="md" textAlign="start">Brak złożonych wniosków</Heading>}
                    </>
                ) : <LoadingWidget withImage={false}/>

            )}
        </Box>
    );
}

function Censuses() {
    const userAuth = useAuth();
    const provider = useApiProvider();

    const [censuses, setCensuses] = useState<CensusForLeaderDTO[]>([]);
    const [isFetched, setIsFetched] = useState<boolean>(false);
    const [errorText, setErrorText] = useState<string>("");

    const getCensuses = async () => {
        provider.getLeaderCensuses()
            .then(censuses => setCensuses(censuses))
            .catch(err => {
                setErrorText(err);
            })
            .finally(() => setIsFetched(true));
    }

    useEffect(() => {
        getCensuses();

        const intervalId = setInterval(getCensuses, 5000);

        return () => clearInterval(intervalId);
    }, []);

    return (
      <>
          <Routes>
            <Route path='/' element={CensusesMenu(censuses, isFetched, errorText)}></Route>
            {censuses.map((census, index) => 
                <React.Fragment key={index}>
                    <Route path={`/${census.CensusId}`} element={<CensusRender registrantId={census.RegistrantId} />} />
                </React.Fragment>
            )}
          </Routes>
      </>
    );
}

export default Censuses;